// Configuración principal de la aplicación
// Siguiendo las mejores prácticas de React + TypeScript

// Tipos para la configuración
interface ApiConfig {
  baseUrl: string;
  starmapUrl: string;
  timeout: number;
  maxRetries: number;
  headers: Record<string, string>;
}

interface AppConfig {
  api: ApiConfig;
  isDevelopment: boolean;
  isProduction: boolean;
}

// Validación de variables de entorno requeridas
const requiredEnvVars = [
  'REACT_APP_API_BASE_URL',
  'REACT_APP_API_KEY'
];

// Configuración de logs
export const LOGS_ENABLED = process.env.REACT_APP_LOG_CONSOLE_ENABLED === 'true';

// Helper para logs condicionales
export const debugLog = (...args: any[]) => {
  if (LOGS_ENABLED) {
    console.log(...args);
  }
};

const missingVars = requiredEnvVars.filter(varName => !process.env[varName]);
if (missingVars.length > 0) {
  throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
}

// Configuración unificada - SIN VALORES POR DEFECTO PARA SEGURIDAD
const config: AppConfig = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL!,
    starmapUrl: process.env.REACT_APP_SSO_URL || 'https://starmap.corvusnocta.org',
    timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
    maxRetries: Number(process.env.REACT_APP_MAX_RETRIES) || 3,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-API-Key': process.env.REACT_APP_API_KEY!
    }
  },
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production'
};

// Exports nombrados para facilidad de uso
export const { api: apiConfig } = config;
export const API_BASE_URL = config.api.baseUrl;
export const STARMAP_URL = config.api.starmapUrl;
export const API_HEADERS = config.api.headers;
export const API_TIMEOUT = config.api.timeout;
export const MAX_RETRIES = config.api.maxRetries;

// Export por defecto de toda la configuración
export default config;
